<div class="modal-header">
  <h3 class="modal-title text-center">Supprimer cette méthode de paiement?</h3>
</div>
<div class="modal-body">
  <div class="row align-items-center">
    <div class="col-auto">

      @if (paymentMethod.brand === 'visa') {
        <i class="fab fa-cc-visa fa-2x"></i>
      }
      @if (paymentMethod.brand === 'amex') {
        <i class="fab fa-cc-amex fa-2x"></i>
      }
      @if (paymentMethod.brand === 'mastercard') {
        <i class="fab fa-cc-mastercard fa-2x"></i>
      }
    </div>
    <div class="col ms-n2">

      <!-- Heading -->
      <h4 class="mb-1">
        {{ paymentMethod.brand | titlecase }} se terminant avec
        {{ paymentMethod.last4 }}
      </h4>

      <!-- Text -->
      <small class="text-muted">
        Expire le {{ paymentMethod.expirationYear }}-{{ paymentMethod.expirationMonth }}
      </small>

    </div>
  </div>
  <div class="m-3">Cette méthode de paiement sera supprimée et ne sera plus accessible. <strong class="text-danger">Ceci
    est
  irréversible.</strong></div>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Supprimer cette méthode de paiement
  </button>
  <button (click)="activeModal.close(false)" class="btn btn-white" type="button">Annuler</button>
</div>
